import request from '@/utils/request'

// 首页列表
export function getList(data) {
    return request({
        url: '/home/news/recom/list',
        method: 'get',
        params:data
    })
}